import { Select } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { useFindProductStandardValues } from "~/gen/api"

interface Props {
  filtersValue: filtersValidationType
  setFiltersValue: (filtersValue: filtersValidationType) => void
}

export const ProductStandardFilter = ({
  filtersValue,
  setFiltersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")
  const { data: standardValues, isLoading } = useFindProductStandardValues({
    ...removeUndefined(filtersValue),
  })

  return (
    <Select
      // defaults
      w={150}
      size="xs"
      searchable
      clearable
      isLoading={isLoading}
      // overrides
      {...props}
      // managed
      data={standardValues?.data.map((standard) => ({
        label: standard.name,
        value: standard.id.toString(),
      }))}
      value={
        filtersValue.standardId ? filtersValue.standardId.toString() : null
      }
      onChange={(value) =>
        setFiltersValue({
          ...filtersValue,
          standardId: value === null ? undefined : Number(value),
        })
      }
      placeholder={t("lists.placeholders.standard")}
    />
  )
}
